// ACTA_AGENT_CONTACT_WHATSAPP_V1
// ACTA_AGENT_TWO_STAGE_PLANNER_V6

import {
  prospects as prospectsApi,
} from "@/api";

import {
  normalizeAgentText,
} from "@/agent/entityResolver";

import {
  resolveAgentContact,
} from "@/agent/resolverRegistry";


const CONTACT_COMMAND_STOPWORDS =
  new Set([
    "ouvre",
    "ouvrir",
    "moi",
    "me",
    "ma",
    "mon",
    "la",
    "le",
    "les",
    "une",
    "un",
    "fiche",
    "contact",
    "contacts",
    "client",
    "prospect",
    "appelle",
    "appeler",
    "appel",
    "contacte",
    "contacter",
    "via",
    "whatsapp",
    "whats",
    "app",
    "telephone",
    "et",
    "puis",
    "de",
    "du",
    "des",
    "a",
    "au",
    "aux",
  ]);


function contactSearchCommand(
  command
) {
  return normalizeAgentText(
    command
  )
    .replace(
      /-/g,
      " "
    )
    .split(" ")
    .filter(
      (token) =>
        token.length >= 2
        && !CONTACT_COMMAND_STOPWORDS
          .has(token)
    )
    .join(" ");
}


export async function prepareContactAction({
  command = "",
  query = "",
}) {
  const response =
    await prospectsApi.list();

  const prospects =
    Array.isArray(response)
      ? response
      : (
        response?.items
        || response?.prospects
        || []
      );

  const semanticQuery =
    String(
      query || ""
    ).trim();

  const searchQuery =
    semanticQuery
    || contactSearchCommand(
      command
    );

  const resolution =
    resolveAgentContact({
      items:
        prospects,
      query:
        searchQuery,
    });

  return {
    contactMatches:
      resolution.matches
      || [],
    contactResolution:
      resolution,
  };
}
